document.addEventListener('DOMContentLoaded', function () {

  // Sluit de Pipeline search-popdown als die toch opent
  const popdown = document.querySelector('#search-popdown');
  if (popdown) {
    const observer = new MutationObserver(function () {
      if (popdown.classList.contains('is-active') || 
          popdown.classList.contains('is-open') ||
          popdown.hasAttribute('open')) {
        popdown.classList.remove('is-active');
        popdown.classList.remove('is-open');
        popdown.removeAttribute('open');
      }
    });
    observer.observe(popdown, { attributes: true, classList: true });
  }

  // Blokkeer form submit
  document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  });

});